import React from 'react'

import { colors } from '@flowwai-frontend/shared/style-guide'

import { IconPropsType } from '../types'

export const ReverseLeftIcon = (props: IconPropsType): React.ReactElement => {
   const { height = 16, stroke = colors['gray-600'], width = 16 } = props

   return (
      <svg
         xmlns='http://www.w3.org/2000/svg'
         width={width}
         height={height}
         viewBox='0 0 16 16'
         fill='none'
      >
         <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M5.25592 0.910734C5.58136 1.23617 5.58136 1.76381 5.25592 2.08925L3.34518 3.99999H9.66667C12.8883 3.99999 15.5 6.61166 15.5 9.83332C15.5 13.055 12.8883 15.6667 9.66667 15.6667H1.33333C0.873096 15.6667 0.5 15.2936 0.5 14.8333C0.5 14.3731 0.873096 14 1.33333 14H9.66667C11.9679 14 13.8333 12.1345 13.8333 9.83332C13.8333 7.53214 11.9679 5.66666 9.66667 5.66666H3.34518L5.25592 7.5774C5.58136 7.90284 5.58136 8.43047 5.25592 8.75591C4.93049 9.08135 4.40285 9.08135 4.07741 8.75591L0.744078 5.42258C0.418641 5.09714 0.418641 4.5695 0.744078 4.24407L4.07741 0.910734C4.40285 0.585297 4.93049 0.585297 5.25592 0.910734Z'
            fill={stroke}
         />
      </svg>
   )
}
